import {useMutation} from 'react-query';
import PostStory from '.';
import {AxiosError} from 'axios';
import {toast} from 'react-toastify';

const usePostStory = () => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: IPostStory) => {
      return PostStory(payload);
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      if (error.response?.status !== 403)
        toast.error(
          error?.response?.data?.message ||
            'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
        );
    },
  });

  return {mutate, isLoading, isSuccess};
};

export default usePostStory;
